import React from "react";
import PageHeaderWrapper from "../../../components/PageHeaderWrapper/index";

import { FormUtils as GetAllFormFields } from 'sz-react-utils'

import moment from "moment";
import { Button, Card, notification, Row, Col, Form, Select, Tabs } from "antd";
import _ from "lodash";

import Request, { API_URL } from "../../../request";
import { connect } from "react-redux";
import { push } from 'connected-react-router'

const TabPane = Tabs.TabPane;

@Form.create()
class LeadSettings extends React.Component {
  state = {
    count: 0,
    activeTab: '0',
    uniArr: [],
    countries: [],
    countryArray: [],
    courseUniversityIds: {},
    courseUniversityIdsJson: {},
    countriesData: [],
    countryids: [],
    checkCountrySetup: false,
    checkUniversitySetup: false,
    trackUserAttendence:true,
    loadResponse: true,
    deductEpfEsic:false,
    phoneCodes:[],
    buttonLoading: [],
    paymentMethods:[],
    paymentOptions:[],
    btnClass: {
      'Save': '#0eb8f7',
      'Update': '#0a8f65',
      'Processing': '#d8cb15',
      'Completed': '#19d815'
    },
    dateFormates: [
      'DD/MM/YYYY', 'MM/dd/yyyy', 'dd.MM.yyyy', 'DD.MM.YYYY', 'DD-MM-YYYY', 'MM-dd-YYYY', 'YYYY.MM.DD', 'DD-MMM-YYYY', 'YYYY-MM-DD'
    ],
    companySettingObject: {}
  };

  checkSetupStatus = async () => {
    const { dispatch } = this.props;
    let response = await Request.checkSetupStatus();
    if (!response.error) {
      if (response.checkCountrySetup && response.checkUniversitySetup) {
        dispatch(push('/timer'))
      }
      this.setState({
        checkCountrySetup: response.checkCountrySetup,
        checkUniversitySetup: response.checkUniversitySetup,
        loadResponse: true
      })
    }
  };

  constructor(props) {
    super(props);
  }

  async componentDidMount() {
    moment('2024-10-08T08:09:06.103+00:00').format('HH:mm:ss')
    let activeUser = JSON.parse(localStorage.getItem('user'))
    this.setState({ activeUser })
    let companySettingObject = await Request.getBusinessDetails(activeUser.businessId);
    if (companySettingObject.selectPaymentMethods) {
      this.setState({ selectPaymentMethods: companySettingObject.selectPaymentMethods })
    }
    this.props.form.setFieldsValue(companySettingObject)

    this.setState({companySettingObject});

    // let response = await Request.getCountriesWithoutBusinessAuth({
    //   results: 10000,
    //   count: 10000
    // });
    // if (response && !response.error) {
    //   let countries = []
    //   let countryArray = [];
    //   let buttonLoading = [];
    //   let phoneCodes = [];
    //   _.each(response.data, (country) => {
    //     countries.push({
    //       _id: country._id,
    //       countryName: country.countryName,
    //       display:country.countryName
    //     })
    //     phoneCodes.push({key: country.countryPhoneCode, id:country.countryPhoneCode, display:country.countryPhoneCode});
    //     countryArray[country._id] = country.countryName;
    //     buttonLoading[country._id] = 'Save';
    //   })
    //   this.setState({ countries, countryArray, buttonLoading, phoneCodes })
    // }
    // await this.loadUni();
  }

  callback = (value) => {
    this.setState({ activeTab: value })
    if (value) {
      let companySettingObject = this.state.companySettingObject;
   if(value == '0') {
        
        if (companySettingObject.studentPaymentOptions) {
          this.setState({ studentPaymentOptions: companySettingObject.studentPaymentOptions })
        }
        if (companySettingObject.selectPaymentMethods) {
          this.setState({ selectPaymentMethods: companySettingObject.selectPaymentMethods })
        }
        if(companySettingObject.paymentMethods){
          this.setState({paymentMethods:companySettingObject.paymentMethods})
        }
        if(companySettingObject.paymentOptions) {
          this.setState({paymentOptions:companySettingObject.paymentOptions})
        }

        setTimeout( () => {
          this.props.form.setFieldsValue(companySettingObject) 
        }, 1000)
         
      }
    }
  }
  

  handleSubmit = async (e) => {
    const { form, dispatch } = this.props
    e.preventDefault();
    form.validateFieldsAndScroll(async (err, valData) => {
      const values = _.clone(valData)  
      values.businessId = this.state.activeUser.businessId;
      if(this.state.paymentMethods.length) {
        values.paymentMethods = this.state.paymentMethods;
      }
      if(this.state.paymentOptions.length) {
        values.paymentOptions = this.state.paymentOptions;
      }
      let response = await Request.addUpdateCompanySetting(values)
      if (response.success) {
        notification.success({
          message: response.message
        })
      } else {
        notification.error({
          messsage: response.message
        })
      }
    })
  }


  loadUni = async () => {
    let arr = await Request.getAllEveryUniversity({ businessId: '1001' });
    this.setState({ uniArr: arr.arr });
  };

  render() {
    const {
      form: { getFieldDecorator, getFieldValue, setFieldsValue },
    } = this.props;

    let { studentPaymentOptions } = this.state;
    let leadInputTypes = {
      fields: [
        {
          label: 'Student Payment Options',
          key: 'studentPaymentOptions',
          type: 'switch',
          onChange: v => {
            setFieldsValue({
              studentPaymentOptions: v
            })
            this.setState({ studentPaymentOptions: v })
          }
        },
        {
          label: 'Consultancy Charges',
          key: 'studentPaymentConsultancyCharges',
          type: 'switch',
          hidden: !studentPaymentOptions,
          onChange: v => {
            setFieldsValue({
              studentPaymentConsultancyCharges: v
            })
            if(v === true) {
              this.setState(prevState => ({
                paymentOptions:[...prevState.paymentOptions, 'Consultancy Charges']
              }))
            }else if (v === false) {
              let data = this.state.paymentOptions
              let foundIndex = data.indexOf('Consultancy Charges')
              this.setState({
                paymentOptions:[...data.slice(0, foundIndex), ...data.slice(foundIndex+1)]
              })
            }
          }
        },
        {
          label: 'Pay After Visa',
          key: 'studentPaymentPayAfterVisa',
          type: 'switch',
          hidden: !studentPaymentOptions,
          onChange: v => {
            setFieldsValue({
              studentPaymentPayAfterVisa: v
            })
            if(v === true) {
              this.setState(prevState => ({
                paymentOptions:[...prevState.paymentOptions, 'Pay After Visa']
              }))
            }else if (v === false) {
              let data = this.state.paymentOptions
              let foundIndex = data.indexOf('Pay After Visa')
              this.setState({
                paymentOptions:[...data.slice(0, foundIndex), ...data.slice(foundIndex+1)]
              })
            }
          }
        },
        {
          label:'Account Payment',
          key:'addInAccountPayment',
          type:'switch',
          onChange:v=>{
            setFieldsValue({
              addInAccountPayment: v
            })
          }
        },
        {
          label: 'Refund Visa Fee to the students?',
          key: 'refundVisaFee',
          type: 'switch',
          onChange: v => {
            setFieldsValue({
              refundVisaFee: v
            })
          }
        },
        {
          label:'University Expiry Notification Emails (comma separated)',
          key:'universityExpireNotification',
          type:'textarea',
        },
        {
          label: 'Use Country-Specific Status (else Static)',
          key: 'useCountrySpecificStatus',
          type: 'switch',
          onChange: v => {
            setFieldsValue({
              useCountrySpecificStatus: v
            })
          }
        },
        // {
        //   label: 'Select Payment Methods',
        //   key: 'selectPaymentMethods',
        //   type: 'switch',
        //   onChange: v => {
        //     setFieldsValue({
        //       selectPaymentMethods: v
        //     })
        //     this.setState({ selectPaymentMethods: v })
        //   }
        // },
        // {
        //   label: 'Cash',
        //   key: 'cashPayment',
        //   type: 'switch',
        //   hidden: !selectPaymentMethods,
        //   onChange: v => {
        //     setFieldsValue({
        //       cashPayment: v
        //     })
        //     if(v === true) {
        //       this.setState(prevState =>({
        //         paymentMethods:[...prevState.paymentMethods, 'Cash Payment']
        //       }))
        //     }else if (v === false) {
        //       let foundIndex = this.state.paymentMethods.indexOf('Cash Payment')
        //       let data = this.state.paymentMethods
        //       this.setState({
        //         paymentMethods:[...data.slice(0, foundIndex), ...data.slice(foundIndex+1)]
        //       })
        //     }
        //   }
        // },
        // {
        //   label: 'Demand Draft',
        //   key: 'demandDraftPayment',
        //   type: 'switch',
        //   hidden: !selectPaymentMethods,
        //   onChange: v => {
        //     setFieldsValue({
        //       demandDraftPayment: v
        //     })
        //     if(v === true) {
        //       this.setState(prevState => ({
        //         paymentMethods: [...prevState.paymentMethods, 'Demand Draft']
        //       }))
        //     }else if (v === false) {
        //       let foundIndex = this.state.paymentMethods.indexOf('Demand Draft')
        //       let data = this.state.paymentMethods
        //       this.setState({
        //         paymentMethods:[...data.slice(0, foundIndex), ...data.slice(foundIndex+1)]
        //       })
        //     }
        //   }
        // },
        // {
        //   label: 'Cheque',
        //   key: 'chequePayment',
        //   type: 'switch',
        //   hidden: !selectPaymentMethods,
        //   onChange: v => {
        //     setFieldsValue({
        //       chequePayment: v
        //     })
        //     if(v === true) {
        //       this.setState(prevState => ({
        //         paymentMethods: [...prevState.paymentMethods, 'Cheque']
        //       }))
        //     }else if (v === false) {
        //       let foundIndex = this.state.paymentMethods.indexOf('Cheque')
        //       let data = this.state.paymentMethods
        //       this.setState({
        //         paymentMethods:[...data.slice(0, foundIndex), ...data.slice(foundIndex+1)]
        //       })
        //     }
        //   }
        // },
        // {
        //   label: 'Bank Transfer',
        //   key: 'bankTransferPayment',
        //   type: 'switch',
        //   hidden: !selectPaymentMethods,
        //   onChange: v => {
        //     setFieldsValue({
        //       bankTransferPayment: v
        //     })
        //     if(v === true) {
        //       this.setState(prevState => ({
        //         paymentMethods: [...prevState.paymentMethods, 'Bank Transfer']
        //       }))
        //     }else if (v === false) {
        //       let foundIndex = this.state.paymentMethods.indexOf('Bank Transfer')
        //       let data = this.state.paymentMethods
        //       this.setState({
        //         paymentMethods:[...data.slice(0, foundIndex), ...data.slice(foundIndex+1)]
        //       })
        //     }
        //   }
        // },
        // {
        //   label: 'Net Banking/UPI Transfers',
        //   key: 'netBankingUpiPayment',
        //   type: 'switch',
        //   hidden: !selectPaymentMethods,
        //   onChange: v => {
        //     setFieldsValue({
        //       netBankingUpiPayment: v
        //     })
        //     if(v === true) {
        //       this.setState(prevState => ({
        //         paymentMethods: [...prevState.paymentMethods, 'Net Banking/UPI Transfers']
        //       }))
        //     }else if (v === false) {
        //       let foundIndex = this.state.paymentMethods.indexOf('Net Banking/UPI Transfers')
        //       let data = this.state.paymentMethods
        //       this.setState({
        //         paymentMethods:[...data.slice(0, foundIndex), ...data.slice(foundIndex+1)]
        //       })
        //     }
        //   }
        // },
        // {
        //   label: 'EFTPOS',
        //   key: 'eftposPayment',
        //   type: 'switch',
        //   hidden: !selectPaymentMethods,
        //   onChange: v => {
        //     setFieldsValue({
        //       eftposPayment: v
        //     })
        //     if(v === true) {
        //       this.setState(prevState => ({
        //         paymentMethods: [...prevState.paymentMethods, 'EFTPOS']
        //       }))
        //     }else if (v === false) {
        //       let foundIndex = this.state.paymentMethods.indexOf('EFTPOS')
        //       let data = this.state.paymentMethods
        //       this.setState({
        //         paymentMethods:[...data.slice(0, foundIndex), ...data.slice(foundIndex+1)]
        //       })
        //     }
        //   }
        // },
        // {
        //   label: 'Stripe',
        //   key: 'stripePayment',
        //   type: 'switch',
        //   hidden: !selectPaymentMethods,
        //   onChange: v => {
        //     setFieldsValue({
        //       stripePayment: v
        //     })
        //     if(v === true) {
        //       this.setState(prevState => ({
        //         paymentMethods: [...prevState.paymentMethods, 'Stripe']
        //       }))
        //     }else if (v === false) {
        //       let foundIndex = this.state.paymentMethods.indexOf('Stripe')
        //       let data = this.state.paymentMethods
        //       this.setState({
        //         paymentMethods:[...data.slice(0, foundIndex), ...data.slice(foundIndex+1)]
        //       })
        //     }
        //   }
        // },
      ]
    }


    return (
      <PageHeaderWrapper title={"Advance Settings"}>

        <Card style={{ marginBottom: 10 }}>
          <Tabs onChange={this.callback} type="card" activeKey={this.state.activeTab}>
            <TabPane tab={`Leads & Inquiry`} key={'0'}>
              <Form onSubmit={this.handleSubmit} style={{ marginTop: 8 }}>
                <Card>
                  <Row>
                    <Col span={24}>
                      <GetAllFormFields
                        apiurl={API_URL}
                        inputSchema={leadInputTypes}
                        refresh={this.refreshFxn}
                        loading={this.props.loading}
                        getFieldDecorator={getFieldDecorator}
                      />
                      <Button
                        type="primary"
                        htmlType="submit"
                        style={{ marginBottom: 10 }}
                        loading={this.props.loading}>
                        SAVE
                      </Button>
                    </Col>
                  </Row>
                </Card>
              </Form>
            </TabPane>
            
          </Tabs>
        </Card>
      </PageHeaderWrapper>
    );
  }
}

const mapStateToProps = ({ global, router }) => ({
  loading: global.buttonLoading,
  categories: global.categories,
  search: router.location.search,
  pathname: router.location.pathname,
});
const mapDispatchToProps = (dispatch) => {
  return {
    dispatch,
  };
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(LeadSettings);
